import {BasePrivilegedRequest, BaseRequest, BaseResponse} from "../../common/types";
import {StringUtil} from "../../common/string_util";
import {$KTM, $KTS, KeyMetadatas, KeyTextStrings} from "../../common/keytext";
import {User} from "../../shared/entities";

export enum CountryCode {
  IN = "in",
}

export type City = {
  countryCode: string,
  name: string,
  popular?: boolean,
}

export function CityId(city: City): string {
  return `${city.countryCode}-${StringUtil.toSlug(city.name)}`;
}

export function CityById(cityId: string): City {
  return CITIES.find(loc => CityId(loc) === cityId);
}

export function CityNameById(cityId: string): string {
  return CityById(cityId)?.name;
}

// This is a super set of all supported cities in all countries.
export const CITIES: City[] = [
  {countryCode: CountryCode.IN, name: "Agra"},
  {countryCode: CountryCode.IN, name: "Ahmedabad", popular: true},
  {countryCode: CountryCode.IN, name: "Ajmer"},
  {countryCode: CountryCode.IN, name: "Aligarh"},
  {countryCode: CountryCode.IN, name: "Allahabad"},
  {countryCode: CountryCode.IN, name: "Alwar"},
  {countryCode: CountryCode.IN, name: "Ambala"},
  {countryCode: CountryCode.IN, name: "Amravati"},
  {countryCode: CountryCode.IN, name: "Amritsar"},
  {countryCode: CountryCode.IN, name: "Anand"},
  {countryCode: CountryCode.IN, name: "Aurangabad"},
  {countryCode: CountryCode.IN, name: "Bangalore", popular: true},
  {countryCode: CountryCode.IN, name: "Bareilly"},
  {countryCode: CountryCode.IN, name: "Bharuch"},
  {countryCode: CountryCode.IN, name: "Bhopal"},
  {countryCode: CountryCode.IN, name: "Bhubaneswar"},
  {countryCode: CountryCode.IN, name: "Bilaspur"},
  {countryCode: CountryCode.IN, name: "Chandigarh"},
  {countryCode: CountryCode.IN, name: "Chennai", popular: true},
  {countryCode: CountryCode.IN, name: "Coimbatore"},
  {countryCode: CountryCode.IN, name: "Cuttack"},
  {countryCode: CountryCode.IN, name: "Dehradun"},
  {countryCode: CountryCode.IN, name: "Delhi", popular: true},
  {countryCode: CountryCode.IN, name: "Dhanbad"},
  {countryCode: CountryCode.IN, name: "Ernakulam"},
  {countryCode: CountryCode.IN, name: "Faizabad"},
  {countryCode: CountryCode.IN, name: "Faridabad"},
  {countryCode: CountryCode.IN, name: "Ghaziabad"},
  {countryCode: CountryCode.IN, name: "Gorakhpur"},
  {countryCode: CountryCode.IN, name: "Greater Noida"},
  {countryCode: CountryCode.IN, name: "Guntur"},
  {countryCode: CountryCode.IN, name: "Gurgaon"},
  {countryCode: CountryCode.IN, name: "Guwahati"},
  {countryCode: CountryCode.IN, name: "Gwalior"},
  {countryCode: CountryCode.IN, name: "Haridwar"},
  {countryCode: CountryCode.IN, name: "Howrah"},
  {countryCode: CountryCode.IN, name: "Hubli"},
  {countryCode: CountryCode.IN, name: "Hyderabad", popular: true},
  {countryCode: CountryCode.IN, name: "Indore"},
  {countryCode: CountryCode.IN, name: "Jabalpur"},
  {countryCode: CountryCode.IN, name: "Jaipur"},
  {countryCode: CountryCode.IN, name: "Jalandhar"},
  {countryCode: CountryCode.IN, name: "Jamshedpur"},
  {countryCode: CountryCode.IN, name: "Jhajjar"},
  {countryCode: CountryCode.IN, name: "Jodhpur"},
  {countryCode: CountryCode.IN, name: "Kannur"},
  {countryCode: CountryCode.IN, name: "Kanpur"},
  {countryCode: CountryCode.IN, name: "Kolhapur"},
  {countryCode: CountryCode.IN, name: "Kolkata", popular: true},
  {countryCode: CountryCode.IN, name: "Kota"},
  {countryCode: CountryCode.IN, name: "Kozhikode"},
  {countryCode: CountryCode.IN, name: "Kurnool"},
  {countryCode: CountryCode.IN, name: "Lucknow", popular: true},
  {countryCode: CountryCode.IN, name: "Ludhiana"},
  {countryCode: CountryCode.IN, name: "Madikeri"},
  {countryCode: CountryCode.IN, name: "Madurai"},
  {countryCode: CountryCode.IN, name: "Mangalore"},
  {countryCode: CountryCode.IN, name: "Mathura"},
  {countryCode: CountryCode.IN, name: "Meerut"},
  {countryCode: CountryCode.IN, name: "Mohali"},
  {countryCode: CountryCode.IN, name: "Moradabad"},
  {countryCode: CountryCode.IN, name: "Mumbai", popular: true},
  {countryCode: CountryCode.IN, name: "Muzaffarnagar"},
  {countryCode: CountryCode.IN, name: "Mysore"},
  {countryCode: CountryCode.IN, name: "Nagpur"},
  {countryCode: CountryCode.IN, name: "Nashik"},
  {countryCode: CountryCode.IN, name: "Navi Mumbai"},
  {countryCode: CountryCode.IN, name: "Navsari"},
  {countryCode: CountryCode.IN, name: "Nellore"},
  {countryCode: CountryCode.IN, name: "Noida"},
  {countryCode: CountryCode.IN, name: "Panchkula"},
  {countryCode: CountryCode.IN, name: "Patna"},
  {countryCode: CountryCode.IN, name: "Puducherry"},
  {countryCode: CountryCode.IN, name: "Pune", popular: true},
  {countryCode: CountryCode.IN, name: "Raigarh"},
  {countryCode: CountryCode.IN, name: "Raipur"},
  {countryCode: CountryCode.IN, name: "Rajahmundry"},
  {countryCode: CountryCode.IN, name: "Rajkot"},
  {countryCode: CountryCode.IN, name: "Ranchi"},
  {countryCode: CountryCode.IN, name: "Salem"},
  {countryCode: CountryCode.IN, name: "Solapur"},
  {countryCode: CountryCode.IN, name: "Srinagar"},
  {countryCode: CountryCode.IN, name: "Surat", popular: true},
  {countryCode: CountryCode.IN, name: "Thane"},
  {countryCode: CountryCode.IN, name: "Thiruvananthapuram"},
  {countryCode: CountryCode.IN, name: "Tiruvallur"},
  {countryCode: CountryCode.IN, name: "Vadodara"},
  {countryCode: CountryCode.IN, name: "Varanasi"},
  {countryCode: CountryCode.IN, name: "Vellore"},
  {countryCode: CountryCode.IN, name: "Vijayawada"},
  {countryCode: CountryCode.IN, name: "Visakhapatnam"},
];

export const CITIES_KTS = new KeyTextStrings(CITIES.map(loc => $KTS(CityId(loc), loc.name)));

export type AccountCreateRequest = BasePrivilegedRequest & {
  email: string,
  password: string,
  firstname: string,
  lastname: string,
}

export type AccountCreateResponse = BaseResponse & {
  uid: string,
  user: User,
}

export type AccountWelcomeRequest = BaseRequest & {
  email: string,
  type: "patient" | "provider",
}

export type AccountResetPwdRequest = BaseRequest & {
  email: string,
}

export type AccountResetPwdQuery = {
  email: string,
  token: string,
}

export type AccountUpdatePwdRequest = BaseRequest & {
  email: string,
  encodedPassword: string,
  token: string,
}

// Notifications

export enum NotificationEventType {
  PROVIDER_WELCOME = "provider/welcome",

  // Practice
  // Appointments
  PRACTICE_APPOINTMENTS_REQUEST = "practice/appointments/request",
  PRACTICE_APPOINTMENTS_STATUS_CHANGE = "practice/appointments/status_change",
  // Messages
  PRACTICE_MESSAGES_NEW_MESSAGE = "practice/appointments/new_message",
  // Billing
  PRACTICE_BILLING_NEW_STATEMENT = "practice/appointments/new_statement",
}

export type NotificationEventRequest<T> = BaseRequest & {
  type: NotificationEventType,
  practiceId?: string, // set for 'practice/...' notification types
  data: T,
}

export type NotificationDataAppointmentRequest = {
  name: string,
  scheduled: number,
  locale?: string,
  providerId: string,
}

export enum NotificationDataAppointmentStatus {
  CONFIRMED = "confirmed",
  CANCELED = "canceled",
}

export type NotificationDataAppointmentStatusChange = {
  providerId: string,
  patientId: string,
  scheduled: number,
  locale?: string,
  status: NotificationDataAppointmentStatus,
}

export const NOTIFICATION_DATA_APPOINTMENT_STATUS_KTS = new KeyTextStrings([
  $KTS(NotificationDataAppointmentStatus.CONFIRMED, "Confirmed"),
  $KTS(NotificationDataAppointmentStatus.CANCELED, "Cancelled"),
]);

export type NotificationDataNewMessage = {
  fromId?: string, // Type id
  toId: string, // Type id
  subject?: string,
  message: string,
}

// Pages

export type BasePageResponse = BaseResponse & {
  page: any,
  linkedPracticePages?: any[],
  linkedProviderPages?: any[],
}

export type PageBySlugResponse = BasePageResponse & {}

export type PageByIdResponse = BasePageResponse & {}

export type ReviewsResponse = BaseResponse & {
  reviews: any,
}

export type PageSearchLocationResponse = BaseRequest & {
  pages: any[],
}

export type SearchListResponse = BaseResponse & {
  list: string[],
}

export type BaseLabTestListResponse = BaseResponse & {
  labTests: any[],
}

export type BaseLabTestResponse = BaseResponse & {
  labTest: any,
}

export type BaseLabTestTemplateResponse = BaseResponse & {
  labTestTemplate: any,
}

export type LabTestBySlugResponse = BaseLabTestResponse & {}

export type LabTestByIdResponse = BaseLabTestResponse & {}

export type BaseLabReportFileResponse = BaseResponse & {
  labReportFile: any,
}

export type LabReportFileByIdResponse = BaseLabReportFileResponse & {}

export type BaseMedicineListResponse = BaseResponse & {
  medicines: any[],
}

export type BaseMedicineResponse = BaseResponse & {
  medicine: any,
}

export type MedicineBySlugResponse = BaseMedicineResponse & {}

export type MedicineByIdResponse = BaseMedicineResponse & {}

export type BasePostResponse = BaseResponse & {
  post: any,
}

export type BasePostsResponse = BaseResponse & {
  posts: any[],
}

export enum MessagingTemplateId {
  // Provider
  PROVIDER_APPOINTMENT_REQUEST = "provider_appointment_request",

  // Patient
  PATIENT_APPOINTMENT_STATUS_CHANGE = "patient_appointment_status_change",
  PATIENT_PAYMENT_BALANCE = "patient_payment_balance",
  PATIENT_RECALL_CHECKUP = "patient_recall_checkup",
  PATIENT_TREATMENT_PRE_SURGERY = "patient_treatment_pre_surgery",
  PATIENT_TREATMENT_POST_SURGERY = "patient_treatment_post_surgery",
  PATIENT_BIRTHDAY_GREETING = "patient_birthday_greeting",
  PATIENT_FESTIVAL_GREETING = "patient_festival_greeting",
}

export type MessagingTemplateMetadata = {
  templateName: string,
  templateText: string,
  templateVariablesCount: number,
  whatsappTemplateName?: string,
}

export const MESSAGING_TEMPLATE_KTM = new KeyMetadatas<MessagingTemplateMetadata>([
  // Sent to Provider
  $KTM(MessagingTemplateId.PROVIDER_APPOINTMENT_REQUEST, {
    templateName: "Appointment / New Request",
    templateText: "Hello {{1}},\n\nYou have a new appointment request by {{2}} on {{3}} at {{4}}.\n\nTo confirm or reject, view requests in the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 4,
    whatsappTemplateName: "dentwyze_transactional_provider_appointment_request",
  }),

  // Sent to Patient
  $KTM(MessagingTemplateId.PATIENT_APPOINTMENT_STATUS_CHANGE, {
    templateName: "Appointment / Status Change",
    templateText: "Hello {{1}},\n\nYour appointment with {{2}} on {{3}} at {{4}} is {{5}}.\n\nTo request a new appointment, cancel, or reschedule, view appointments in the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 5,
    whatsappTemplateName: "dentwyze_transactional_patient_appointment_status_change",
  }),
  $KTM(MessagingTemplateId.PATIENT_PAYMENT_BALANCE, {
    templateName: "Payment / Balance",
    templateText: "Hi {{1}},\n\nYou have a balance of {{2}} due. Please make a payment at your earliest convenience.\n\nFrom {{3}}.\n\nIf you have any questions or concerns about this message, please contact us at {{4}} or through the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 4,
    whatsappTemplateName: "dentwyze_transactional_patient_payment_balance",
  }),
  $KTM(MessagingTemplateId.PATIENT_TREATMENT_PRE_SURGERY, {
    templateName: "Treatment / Pre-surgery",
    templateText: "Hello {{1}},\n\nWishing you a all the best for your upcoming treatment.\n\nFrom {{2}}.\n\nIf you have any questions or concerns about this message, please contact us at {{3}} or through the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 3,
    whatsappTemplateName: "dentwyze_marketing_patient_pre_surgery",
  }),
  $KTM(MessagingTemplateId.PATIENT_TREATMENT_POST_SURGERY, {
    templateName: "Treatment / Post-surgery",
    templateText: "Hello {{1}},\n\nWishing you a quick recovery.\n\nFrom {{2}}.\n\nIf you have any questions or concerns about this message, please contact us at {{3}} or through the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 3,
    whatsappTemplateName: "dentwyze_marketing_patient_post_surgery",
  }),
  $KTM(MessagingTemplateId.PATIENT_RECALL_CHECKUP, {
    templateName: "Recall / Check Up",
    templateText: "Hi {{1}},\n\nIt's time for your dental check-up. Regular checks help maintain oral health and keep you smiling.\n\nFrom {{2}}.\n\nTo request a new appointment, cancel, or reschedule, please contact us at {{3}} or view appointments in the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 3,
    whatsappTemplateName: "dentwyze_marketing_patient_recall_checkup",
  }),
  $KTM(MessagingTemplateId.PATIENT_BIRTHDAY_GREETING, {
    templateName: "Birthday / Greeting",
    templateText: "Dear {{1}},\n\nWishing you many happy returns of the day. Have a wonderful birthday!\n\nFrom {{2}}.\n\nIf you have any questions or concerns about this message, please contact us at {{3}} or through the myCare app. Download at https://dentwyze.in/download",
    templateVariablesCount: 3,
    whatsappTemplateName: "dentwyze_marketing_patient_birthday_greeting",
  }),
]);

export enum MessagingSendChannel {
  EMAIL = "email",
  SMS = "sms",
  WHATSAPP = "whatsapp",
}

export type MessagingSendChannelMetadata = {
  text: string,
}

export const MESSAGING_SEND_CHANNEL_KTM = new KeyMetadatas<MessagingSendChannelMetadata>([
  $KTM(MessagingSendChannel.SMS, {text: "SMS"}),
  $KTM(MessagingSendChannel.WHATSAPP, {text: "WhatsApp"}),
]);

export type MessagingSendRequest = BaseRequest & {
  channel: MessagingSendChannel,
  templateId: MessagingTemplateId,
  fromId: string,
  to: string,
  templateVariables?: string[],
}

export enum SmsDeliveryStatus {
  AWAITED = "AWAITED",
  DELIVERED = "DELIVERED",
  NO_CREDITS = "NO-CREDITS",
  UNDELIVERED = "UNDELIVERED",
  DND = "DND",
  SERIES_BLOCKED = "SERIES-BLOCKED",
  INVALID_NUMBER = "INVALID-NUMBER",
  SERVER_ERROR = "SERVER-ERROR",
  SPAM = "SPAM",
  BLACKLISTED = "BLACKLISTED",
  FAILED = "FAILED",
  MOB_OFF = "MOB-OFF",
  EXPIRED = "EXPIRED",
  REJECTED = "REJECTED",
  OPERATOR_NACK = "OPERATOR-NACK",
}

export enum MailTemplateId {
  RESET_PASSWORD = "reset_password",

  PG_PROVIDER_CLAIM_CODE = "pg_provider.claim_code",
  PG_PRACTICE_CLAIM_CODE = "pg_practice.claim_code",

  PROVIDER_INTRODUCTION = "provider_introduction",
  PROVIDER_WELCOME = "provider_welcome",
  PROVIDER_NOTIFICATION = "provider_notification",

  PATIENT_WELCOME = "patient_welcome",
  PATIENT_NOTIFICATION = "patient_notification",

  VANTAGE_CAMPAIGNS_BIRTHDAY = "vantage_campaigns_birthday",
  VANTAGE_CAMPAIGNS_FESTIVAL = "vantage_campaigns_festival",
}

export type MailSendRequest = BaseRequest & {
  templateId: MailTemplateId,
  fromId: string,
  to: string,
  replaceStrings?: string[][],
}

// For SMS and WhatsApp, see MessagingSendRequest.

export enum ScheduledTasksGranularity {
  DAY = "day",
  HOUR = "hour",
  MINUTE = "minute",
}

export type ScheduledTasksRequest = BaseRequest & {
  granularity: ScheduledTasksGranularity,
  type?: string,
  payload?: any,
}

export type ScheduledTasksResponse = BasePageResponse & {}

export enum VoiceType {
  MALE_1 = "male_1",
  MALE_2 = "male_2",
  MALE_3 = "male_3",
  MALE_4 = "male_4",
  FEMALE_1 = "female_1",
  FEMALE_2 = "female_2",
  FEMALE_3 = "female_3",
  FEMALE_4 = "female_4",
  NEUTRAL_1 = "neutral_1",
  NEUTRAL_2 = "neutral_2",
  NEUTRAL_3 = "neutral_3",
  NEUTRAL_4 = "neutral_4",
}

export type ChatContent = {
  role: "user" | "assistant",
  text: string,
}

export type ChatRequest = BaseRequest & {
  history: ChatContent[],
}

export type ChatResponse = BaseResponse & {
  response: {
    content: ChatContent,
    status?: "complete" | "incomplete",
  },
}

export type SttContent = {
  text: string,
}

export type SttRequest = BaseRequest & {
  encodedFile: string,
}

export type SttResponse = BaseResponse & {
  response: {
    content: SttContent,
    status?: "complete" | "incomplete",
  },
}

export type TtsContent = {
  encodedFile: string,
}

export type TtsRequest = BaseRequest & {
  voiceType: VoiceType,
  text: string,
}

export type TtsResponse = BaseResponse & {
  response: {
    content: TtsContent,
    status?: "complete" | "incomplete",
  },
}

export type DevicesLoginResponse = BaseResponse & {
  login: {practiceId: string, email: string, password: string},
}

export type DevicesSetupRequest = BaseRequest & {
  practiceId: string,
  setupCode: string,
}

export type DevicesSetupResponse = BaseResponse & {
  device: any, // Device
}

export type DevicesTeardownRequest = BaseRequest & {
  practiceId: string,
  deviceId: string;
}

export type DevicesTeardownResponse = BaseResponse & {}

export type VantageSiteResponse = BaseResponse & {
  site: any,
}

export type BaseVantageSitesRequest = BaseRequest & {
  practiceId: string,
  siteId: string,
}

export type VantageSitesCreateRequest = BaseVantageSitesRequest & {}

export type VantageSitesCreateResponse = BaseResponse & {}

export type VantageSitesDeleteRequest = BaseVantageSitesRequest & {}

export type VantageSitesDeleteResponse = BaseResponse & {}

export enum VantageSiteBuildStatus {
  NONE = "none",
  QUEUED = "queued",
  BUILDING = "building",
  SUCCESS = "success",
  ERROR = "error",
}

export type VantageSitesBuildRequest = BaseVantageSitesRequest & {}

export type VantageSitesBuildResponse = BaseResponse & {
  buildStatus: VantageSiteBuildStatus,
}

export type VantageSitesBuildStatusResponse = BaseResponse & {
  buildStatus: VantageSiteBuildStatus,
}

export type VantageSitesCustomDomainRequest = BaseVantageSitesRequest & {
  name: string,
}

export type VantageSitesCustomDomainResponse = BaseResponse & {}
